import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { API } from "../api";

/* ── Inline CSS Injection (Scoped to .amber-login-wrapper) ── */
const STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

  .amber-login-wrapper {
    min-height: 100vh;
    width: 100%;
    background-color: #F9F7F2;
    font-family: 'Inter', sans-serif;
    display: flex;
    flex-direction: column;
    padding: 24px;
    box-sizing: border-box;
  }

  .amber-login-wrapper *, .amber-login-wrapper *::before, .amber-login-wrapper *::after { box-sizing: border-box; }

  .amber-login-wrapper .header { display: flex; align-items: center; margin-bottom: 24px; padding-left: 4px; }
  .amber-login-wrapper .logo-badge { display: inline-flex; align-items: center; gap: 0; font-size: 22px; font-weight: 700; color: #1a1a1a; }
  .amber-login-wrapper .logo-badge .amber { background: #2C908D; padding: 2px 8px; border-radius: 6px; margin-right: 5px; color: #1a1a1a; }
  .amber-login-wrapper .logo-icon { display: inline-flex; flex-direction: column; align-items: center; margin-right: 8px; }
  .amber-login-wrapper .logo-icon .car-top { width: 16px; height: 7px; background: #1a1a1a; border-radius: 4px 4px 0 0; }
  .amber-login-wrapper .logo-icon .car-body { width: 22px; height: 10px; background: #1a1a1a; border-radius: 2px; }

  .amber-login-wrapper .container { flex: 1; display: flex; gap: 28px; max-width: 1100px; width: 100%; margin: 0 auto; align-items: stretch;justify-content: center; }

  .amber-login-wrapper .left-panel { flex: 1.2; background: #fff; border-radius: 32px; padding: 36px 32px; display: flex; flex-direction: column; align-items: center; position: relative; box-shadow: 0 4px 20px rgba(0,0,0,0.04); overflow: hidden; }
  .amber-login-wrapper .ill-label { font-size: 13.5px; font-weight: 600; color: #1a1a1a; margin-bottom: 12px; align-self: flex-start; padding-left: 8px; z-index: 2; }
  .amber-login-wrapper .img-top { width: 100%; max-width: 380px; height: 200px; object-fit: cover; object-position: top left; border-radius: 12px; z-index: 2; background-color: #f3f4f6; }
  .amber-login-wrapper .img-bottom { width: 100%; max-width: 380px; height: 200px; object-fit: cover; object-position: bottom left; border-radius: 12px; margin-top: auto; z-index: 2; background-color: #f3f4f6; }

  .amber-login-wrapper .wavy-wrap { position: absolute; top: 46%; left: 50%; transform: translateX(-50%); width: 180px; height: 100px; z-index: 1; }
  .amber-login-wrapper .wavy-wrap .curve { width: 100%; height: 100%; border-right: 2px solid rgba(30,30,80,0.25); border-bottom: 2px solid rgba(30,30,80,0.25); border-bottom-right-radius: 70px; }
  .amber-login-wrapper .dot1, .amber-login-wrapper .dot2 { position: absolute; width: 13px; height: 8px; background: #2C908D; border-radius: 2px; }
  .amber-login-wrapper .dot1 { top: 8%; right: -6px; transform: rotate(45deg); }
  .amber-login-wrapper .dot2 { bottom: -5px; left: 18%; transform: rotate(-25deg); }

  .amber-login-wrapper .right-panel { flex: 1; max-width: 460px; background: #fff; border-radius: 32px; padding: 40px; box-shadow: 0 4px 20px rgba(0,0,0,0.04); display: flex; flex-direction: column; justify-content: center; }
  .amber-login-wrapper .form-title { 
    font-size: 26px;
    font-weight: 700;
    margin-bottom: 8px;

    /* Text Gradient Magic */
    background: linear-gradient(135deg, #116d70, #064d52);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;  
  }
  .amber-login-wrapper .form-sub { font-size: 13.5px; color: #9ca3af; line-height: 1.55; margin-bottom: 15px; padding-right: 20px; }

  .amber-login-wrapper .error-box { background: #fee2e2; border: 1px solid #f87171; border-radius: 12px; padding: 12px 16px; margin-bottom: 18px; color: #b91c1c; font-size: 13px; display: flex; align-items: center; gap: 8px; }
  .amber-login-wrapper .error-box svg { flex-shrink: 0; }

  .amber-login-wrapper .field-group { margin-bottom: 20px; }
  .amber-login-wrapper label { display: block; font-size: 13.5px; font-weight: 500; color: #2C908D; margin-bottom: 3px; }
  .amber-login-wrapper .input-wrap { position: relative; }
  .amber-login-wrapper .field-icon { position: absolute; left: 14px; top: 50%; transform: translateY(-50%); color: #9ca3af; font-size: 14px; pointer-events: none; display: flex; }

  .amber-login-wrapper input[type="text"], 
  .amber-login-wrapper input[type="email"], 
  .amber-login-wrapper input[type="password"] { width: 100%; padding: 12px 16px 12px 42px; background: #fff; border: 1px solid #e5e7eb; border-radius: 12px; color: #1a1a1a; font-size: 14px; font-family: 'Inter', sans-serif; outline: none; transition: all 0.2s; }
  .amber-login-wrapper input:focus { border-color: #2C908D;}
  .amber-login-wrapper input::placeholder { color: #9ca3af; }
  .amber-login-wrapper input:-webkit-autofill { -webkit-box-shadow: 0 0 0px 1000px #fff inset; }

  .amber-login-wrapper .eye-btn { position: absolute; right: 13px; top: 50%; transform: translateY(-50%); background: none; border: none; cursor: pointer; color: #9ca3af; font-size: 17px; padding: 4px; display: flex; align-items: center; transition: color 0.2s; }
  .amber-login-wrapper .eye-btn:hover { color: #4b5563; }

  .amber-login-wrapper .captcha-row { display: flex; align-items: center; gap: 12px; margin-bottom: 10px; }
  .amber-login-wrapper .captcha-box { flex: 1; min-height: 46px; background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 12px; display: flex; align-items: center; justify-content: center; overflow: hidden; padding: 4px 8px; cursor: pointer; transition: border-color 0.2s; font-size: 22px; font-weight: 700; letter-spacing: 6px; color: #374151; user-select: none; }
  .amber-login-wrapper .captcha-box:hover { border-color: #2C908D; }
  .amber-login-wrapper .refresh-btn { background: #fff; border: 1px solid #e5e7eb; color: #6b7280; border-radius: 8px; padding: 10px 12px; cursor: pointer; font-size: 18px; transition: all 0.2s; display: flex; align-items: center; justify-content: center; }
  .amber-login-wrapper .refresh-btn:hover { color: #1a1a1a; border-color: #9ca3af; }

  .amber-login-wrapper .forgot-row { display: flex; justify-content: flex-end; margin-bottom: 18px; }
  .amber-login-wrapper .forgot-link { font-size: 12px; font-weight: 500; color: #4b5563; text-decoration: none; }
  .amber-login-wrapper .forgot-link:hover { color: #2C908D; }

  .amber-login-wrapper .login-btn { width: 100%; padding: 14px; background: #2C908D; border: none; border-radius: 12px; color: #FFF; font-size: 15px; font-weight: 600; font-family: 'Inter', sans-serif; cursor: pointer; transition: background 0.2s; display: flex; align-items: center; justify-content: center; gap: 8px; }
  .amber-login-wrapper .login-btn:hover:not(:disabled) { background: #2C908D; }
  .amber-login-wrapper .login-btn:disabled { opacity: 0.65; cursor: not-allowed; }

  @keyframes spin { to { transform: rotate(360deg); } }
  .amber-login-wrapper .spinner { display: inline-block; width: 18px; height: 18px; border: 2px solid rgba(0,0,0,0.2); border-top-color: #1a1a1a; border-radius: 50%; animation: spin 0.7s linear infinite; }

  @keyframes shake {
    0%,100% { transform: translateX(0); }
    25% { transform: translateX(-6px); }
    75% { transform: translateX(6px); }
  }
  .amber-login-wrapper .shake { animation: shake 0.4s ease; }
`;

export default function Login() {
  // --- UNTOUCHED JSX LOGIC ---
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [captcha, setCaptcha] = useState("");
  const [showPass, setShowPass] = useState(false);
  const [captchaSvg, setCaptchaSvg] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [shakeForm, setShakeForm] = useState(false);

  useEffect(() => {
    fetchCaptcha();
  }, []);

  const fetchCaptcha = async () => {
    try {
      const res = await API.get("/auth/captcha", { responseType: "text" });
      setCaptchaSvg(res.data);
      setCaptcha("");
    } catch (e) {
      console.error(e);
    }
  };

  const shake = () => {
    setShakeForm(true);
    setTimeout(() => setShakeForm(false), 500);
  };

  const handleLogin = async () => {
    if (!email || !password || !captcha) {
      setError("All fields are required");
      shake();
      return;
    }
    setLoading(true);
    setError("");
    try {
      const res = await API.post("/auth/login", {
        loginid: email,
        password,
        captcha,
      });
      if (res.data.status === 1) {
        localStorage.setItem("token", res.data.token);
        localStorage.setItem("user", JSON.stringify(res.data.user));
        navigate("/dashboard");
      } else if (res.data.status === 2) {
        setError("Invalid username or password");
        shake();
        fetchCaptcha();
      } else if (res.data.status === 3) {
        setError("Invalid captcha — try again");
        shake();
        fetchCaptcha();
      } else {
        setError("Something went wrong");
        shake();
      }
    } catch (e) {
      setError("Server error. Please try again.");
      shake();
    }
    setLoading(false);
  };

  const handleKey = (e) => {
    if (e.key === "Enter") handleLogin();
  };

  // --- AMBER CABS DESIGN UI RETURN ---
  return (
    <>
      <style>{STYLES}</style>
      <div className="amber-login-wrapper">
        {/* ── MAIN CONTAINER ── */}
        <div className="container">
          {/* RIGHT PANEL: Login Form */}
          <div
            className={`right-panel ${shakeForm ? "shake" : ""}`}
            id="loginPanel"
          >
            <h2 className="form-title">Welcome,</h2>
            <p className="form-sub">Sign in to your admin panels</p>

            {/* Error box */}
            {error && (
              <div className="error-box">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M12 2L1 21h22L12 2zm0 3.5L20.5 19h-17L12 5.5zM11 10v4h2v-4h-2zm0 6v2h2v-2h-2z" />
                </svg>
                <span>{error}</span>
              </div>
            )}

            {/* Email Field */}
            <div className="field-group">
              <label htmlFor="email">User ID</label>
              <div className="input-wrap">
                <span className="field-icon">
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                    <polyline points="22,6 12,13 2,6" />
                  </svg>
                </span>
                <input
                  type="email"
                  id="email"
                  placeholder="Enter your ID"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  onKeyDown={handleKey}
                  autoComplete="username"
                />
              </div>
            </div>

            {/* Password Field */}
            <div className="field-group">
              <label htmlFor="password">Password</label>
              <div className="input-wrap">
                <span className="field-icon">
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                  </svg>
                </span>
                <input
                  type={showPass ? "text" : "password"}
                  id="password"
                  placeholder="Enter your Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  onKeyDown={handleKey}
                  autoComplete="current-password"
                  style={{ paddingRight: "44px" }}
                />
                <button
                  className="eye-btn"
                  onClick={() => setShowPass((p) => !p)}
                  type="button"
                >
                  {showPass ? (
                    <svg
                      width="17"
                      height="17"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
                      <line x1="1" y1="1" x2="23" y2="23" />
                    </svg>
                  ) : (
                    <svg
                      width="17"
                      height="17"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                      <circle cx="12" cy="12" r="3" />
                    </svg>
                  )}
                </button>
              </div>
            </div>

            {/* Captcha Field */}
            <div className="field-group">
              <label>Security Check</label>
              <div className="captcha-row">
                <div
                  className="captcha-box"
                  title="Click to refresh"
                  onClick={fetchCaptcha}
                  dangerouslySetInnerHTML={{ __html: captchaSvg }}
                />
                <button
                  className="refresh-btn"
                  onClick={fetchCaptcha}
                  title="Refresh captcha"
                  type="button"
                >
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline points="23 4 23 10 17 10" />
                    <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10" />
                  </svg>
                </button>
              </div>
              <div className="input-wrap" style={{ marginTop: "8px" }}>
                <span className="field-icon">
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                  </svg>
                </span>
                <input
                  type="text"
                  placeholder="Enter captcha text"
                  value={captcha}
                  onChange={(e) => setCaptcha(e.target.value)}
                  onKeyDown={handleKey}
                />
              </div>
            </div>

            {/* Login Button */}
            <button
              className="login-btn"
              onClick={handleLogin}
              disabled={loading}
              type="button"
            >
              {loading ? <span className="spinner"></span> : <span>Login</span>}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
